import { VideoStreamController } from './VideoStreamController';
import { VideoStreamSupportedMediaType } from '../types';
import { VLCVideoStreamControllerConfiguration } from './types';

/**
 * Video Stream for Vlc
 *
 * type hdmi_windows type will have its src configuration autofilled
 * in the layout editor as 'dshow://'
 * @see {@link https://wiki.videolan.org/Documentation:Modules/dshow/}
 */
export class VideoStreamExternalVLCController extends VideoStreamController {
    readonly type: VideoStreamSupportedMediaType.VLC = VideoStreamSupportedMediaType.VLC;
    private configuration: VLCVideoStreamControllerConfiguration;
    readonly #vlcApi: ExternalAppVLCController;
    vlcControlID: number | null = null;
    streamElement: HTMLDivElement;

    constructor(
        configuration: VLCVideoStreamControllerConfiguration,
        vlcApi: ExternalAppVLCController
    ) {
        super();

        this.configuration = configuration;

        this.#vlcApi = vlcApi;

        this.streamElement = document.createElement('div');
        this.streamElement.style.height = '100%';
        this.streamElement.style.width = '100%';
    }

    async canBePlayed(): Promise<boolean> {
        return typeof this.configuration.url === 'string' && this.configuration.url.length > 0;
    }

    async play(): Promise<void> {
        const bounds = this.streamElement.getBoundingClientRect();
        this.vlcControlID = this.#vlcApi.CreateVlcControl(
            this.configuration.url,
            Math.round(bounds.left),
            Math.round(bounds.top),
            Math.round(bounds.width),
            Math.round(bounds.height),
            this.configuration.aspect_ratio || '',
            this.configuration.video_device || ''
        );
    }

    async pause(): Promise<void> {
        //observing the signage, it is noted that when this widget throws an error, that error is
        //rendered within the widget DOM element. Presumably, the color and background of the DOM
        //element is being set here to facilitate readability of that error message.
        if (this._isPlaying) {
            this.streamElement.style.color = 'white';
            this.streamElement.style.backgroundColor = 'black';
        }

        if (this.vlcControlID) {
            //the PauseVlcControl method does not work in older version of C# player
            //this.#vlcApi.PauseVlcControl(this.vlcControlID);

            this.#vlcApi.DestroyVlcControl(this.vlcControlID);
            this.vlcControlID = null;
        }

        return super.pause();
    }
}
